import axios from "axios";
import { authHeader } from "@/helpers/API/Auth/auth.header.js";
const API_URL = process.env.VUE_APP_ROOT_API;

class SourceService {
  // Get All Lead Sources Non-Super Admin
  async getleadSourcesNonSup(filter = "") {
    return await axios
      .get(API_URL + `crm/lead-source${filter}`, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get All Lead Sources
  async getLeadSources(filter = "") {
    return await axios
      .get(API_URL + `crm/spa/lead-source${filter}`, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Add New Lead Source
  async addLeadSource(data) {
    return await axios
      .post(API_URL + "crm/spa/lead-source", data, { headers: authHeader() })
      .then((res) => {
        return res.data;
      });
  }

  // Edit Lead Source
  async updateLeadSource(id, data) {
    return await axios
      .patch(API_URL + `crm/spa/lead-source/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      });
  }

  // Delete Lead Source
  async deleteLeadSource(id) {
    return await axios
      .delete(API_URL + `crm/spa/lead-source/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      });
  }
}
export default new SourceService();
